import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { SHOW_SIGN_UP_ANIMATION_240430 } from "@faire/web-api--source/indigofair/settings/SHOW_SIGN_UP_ANIMATION_240430";

export const getSettingShowSignUpAnimation = () => {
  return getSettingValueWithoutAssignment(SHOW_SIGN_UP_ANIMATION_240430, false);
};
